import {
  Banknote,
  CircleCheck,
  CircleX,
  ClipboardList,
  Handshake,
  MessagesSquare,
  PackageCheck,
  PackageX,
  Send,
  TriangleAlert,
  Undo2,
} from "lucide-react";

import { type QuickFilter } from "@/components/QuickFilterCards";
import { OfferStatus } from "../RepresentativeOffers/components/OfferCard/interfaces";

const TRANSLATION_PREFIX = "home.representative.quickFilters";

const HEALTHY_ICON_CLASS = "text-green-600 bg-green-100";
const WARNING_ICON_CLASS = "text-brown-600 bg-brown-100";
const ATTENTION_ICON_CLASS = "text-red-600 bg-red-100";

/**
 * Ids are `OfferStatus` values, so a selection travels as the offer list's `status` filter.
 * ExchangeAgreed is excluded to match the offers page filter dropdown, which never offered it.
 */
export type OfferQuickFilterId = Exclude<
  OfferStatus,
  | OfferStatus.ExchangeAgreed
  | OfferStatus.ExchangeDetailsConfirmed
  | OfferStatus.ExchangeRejected
  | OfferStatus.ExchangeRejectionDisputed
>;

/** Array order is the display order inside each card. */
export const OFFER_QUICK_FILTERS: QuickFilter<OfferQuickFilterId>[] = [
  {
    id: OfferStatus.New,
    group: "healthy",
    icon: Send,
    iconClassName: HEALTHY_ICON_CLASS,
    labelKey: `${TRANSLATION_PREFIX}.offers.new`,
  },
  {
    id: OfferStatus.Accepted,
    group: "healthy",
    icon: CircleCheck,
    iconClassName: HEALTHY_ICON_CLASS,
    labelKey: `${TRANSLATION_PREFIX}.offers.accepted`,
  },
  {
    id: OfferStatus.OfferDone,
    group: "healthy",
    icon: PackageCheck,
    iconClassName: HEALTHY_ICON_CLASS,
    labelKey: `${TRANSLATION_PREFIX}.offers.offerDone`,
  },
  {
    id: OfferStatus.ExchangeDone,
    group: "healthy",
    icon: Handshake,
    iconClassName: HEALTHY_ICON_CLASS,
    labelKey: `${TRANSLATION_PREFIX}.offers.exchangeDone`,
  },
  {
    id: OfferStatus.Negotiating,
    group: "warning",
    icon: MessagesSquare,
    iconClassName: WARNING_ICON_CLASS,
    labelKey: `${TRANSLATION_PREFIX}.offers.negotiating`,
  },
  {
    id: OfferStatus.ExchangeDetailsUpdated,
    group: "warning",
    icon: ClipboardList,
    iconClassName: WARNING_ICON_CLASS,
    labelKey: `${TRANSLATION_PREFIX}.offers.exchangeDetailsUpdated`,
  },
  {
    id: OfferStatus.ExchangeDetailsDisputed,
    group: "warning",
    icon: TriangleAlert,
    iconClassName: WARNING_ICON_CLASS,
    labelKey: `${TRANSLATION_PREFIX}.offers.exchangeDetailsDisputed`,
  },
  {
    id: OfferStatus.ExchangePaymentPending,
    group: "warning",
    icon: Banknote,
    iconClassName: WARNING_ICON_CLASS,
    labelKey: `${TRANSLATION_PREFIX}.offers.exchangePaymentPending`,
  },
  {
    id: OfferStatus.Rejected,
    group: "attention",
    icon: CircleX,
    iconClassName: ATTENTION_ICON_CLASS,
    labelKey: `${TRANSLATION_PREFIX}.offers.rejected`,
  },
  {
    id: OfferStatus.Recalled,
    group: "attention",
    icon: Undo2,
    iconClassName: ATTENTION_ICON_CLASS,
    labelKey: `${TRANSLATION_PREFIX}.offers.recalled`,
  },
  {
    id: OfferStatus.ExchangeCanceled,
    group: "attention",
    icon: PackageX,
    iconClassName: ATTENTION_ICON_CLASS,
    labelKey: `${TRANSLATION_PREFIX}.offers.deliveryRejected`,
  },
];
